import React from 'react';
import { Grid } from '@material-ui/core';

let FACEICONSNAME = ['[龇牙]', '[调皮]', '[流汗]', '[偷笑]', '[再见]', '[敲打]', '[擦汗]', '[猪头]', '[玫瑰]', '[流泪]', '[大哭]',
    '[嘘]', '[酷]', '[抓狂]', '[委屈]', '[便便]', '[炸弹]', '[菜刀]', '[可爱]', '[色]',
    '[害羞]', '[得意]', '[吐]', '[微笑]', '[怒]', '[尴尬]', '[惊恐]', '[冷汗]', '[爱心]', '[示爱]',
    '[白眼]', '[傲慢]', '[难过]', '[疑问]', '[困]', '[么么哒]', '[憨笑]', '[衰]', '[撇嘴]',
    '[阴险]', '[奋斗]', '[发呆]', '[右哼哼]', '[抱抱]', '[坏笑]', '[鄙视]', '[晕]', '[可怜]', '[强]', '[弱]',
    '[握手]', '[胜利]', '[抱拳]', '[凋谢]', '[米饭]', '[蛋糕]', '[西瓜]', '[啤酒]', '[瓢虫]', '[勾引]', '[OK]',
    '[爱你]', '[咖啡]', '[刀]', '[差劲]', '[拳头]', '[心碎了]', '[太阳]', '[礼物]', '[皮球]', '[骷髅]', '[闪电]',
    '[饥饿]', '[困]', '[咒骂]', '[折磨]', '[抠鼻]', '[鼓掌]', '[糗大了]', '[左哼哼]', '[打哈欠]', '[快哭了]', '[吓]', '[篮球]',
    '[乒乓]', '[NO]', '[闭嘴]', '[猫咪]', '[红双喜]', '[鞭炮]', '[红灯笼]', '[麻将]', '[麦克风]', '[礼品袋]', '[信封]', '[象棋]', '[彩带]',
    '[蜡烛]', '[爆筋]', '[棒棒糖]', '[奶瓶]', '[面条]', '[香蕉]', '[飞机]', '[左车头]', '[车厢]', '[右车头]', '[多云]', '[下雨]', '[钞票]',
    '[熊猫]', '[灯泡]', '[风车]', '[闹钟]', '[雨伞]', '[彩球]', '[钻戒]', '[沙发]', '[纸巾]', '[手枪]', '[青蛙]']

 
export default class ChatUtils {

    static createHtml(text,textColor = '#0D0D0D') {
        let dom = ChatUtils.decodeText(text);
        return (
            <span >
                {
                    dom.map((item, i) => (
                        ChatUtils.createEle(item, i,textColor)
                    ))
                }
            </span>
        )
    }

    static createEle(ele, i,textColor) {
        if (ele.name == 'text') {
            return (<span key={i} style={{ fontSize: 12, color: textColor, lineHeight: 2.4, wordBreak: 'break-all' }}>{ele.text}</span>);
        } else if (ele.name == 'img') {
            return (<img key={i} src={require('../images/emoji/' + ele.src + '@2x.png')} style={{ width: 23, height: 23, marginTop:2,verticalAlign: 'middle' }} />);
        }
        return (<span key={i}></span>)
    }

    static isEmoji(name) {
        for (let i = 0; i < FACEICONSNAME.length; i++) {
            if (FACEICONSNAME[i] === name) {
                return true;
            }
        }
        return false;
    }

    static decodeText(text) {
        let dom = [];
        let temp = text;
        let left = -1;
        let right = -1;
        while (temp !== '' && typeof (temp) !== 'undefined') {
            left = temp.indexOf('[');
            right = temp.indexOf(']');
            switch (left) {
                case 0:
                    if (right == -1) {
                        dom.push({ name: 'text', text: temp });
                        temp = '';
                    } else {
                        let _emoji = temp.slice(0, right + 1);
                        if (ChatUtils.isEmoji(_emoji)) {
                            dom.push({ name: 'img', src: _emoji });
                            temp = temp.substring(right + 1);
                        } else {
                            dom.push({ name: 'text', text: '[' });
                            temp = temp.slice(1);
                        }

                    }
                    break;
                case -1:
                    dom.push({ name: 'text', text: temp });
                    temp = '';
                    break;
                default:
                    dom.push({ name: 'text', text: temp.slice(0, left) });
                    temp = temp.substring(left);
                    break;
            }
        }

        return dom;
    }
}